import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { deletecompte } from "../services/LoginService";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet-async";

export default function SupprimerComptePage() {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const result = await deletecompte(formData.email, formData.password);
            if (result.success) {
                toast.success(result.message || "Votre compte a été supprimé avec succès !", {
                    position: "top-right",
                    autoClose: 5000,
                });
                setFormData({ email: "", password: "" });
            } else {
                toast.error(result.message || "Erreur lors de la suppression du compte.", {
                    position: "top-right",
                    autoClose: 5000,
                });
            }
        } catch (err) {
            toast.error("Erreur inattendue lors de l'envoi.", {
                position: "top-right",
                autoClose: 5000,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>Supprimer mon compte — Thrundrz</title>
                <meta name="description" content="Supprimez votre compte Thrundrz à tout moment." />
                <link rel="canonical" href="https://thrundrz.fr/supprimer-compte" />
            </Helmet>
            <Navbar />
            <main className="lg:min-h-screen bg-color4 text-color2 py-16 pt-24 px-4 lg:pt-36">
                <div className="max-w-lg mx-auto bg-color5 rounded-2xl lg:p-8 p-4 shadow-lg">
                    <h1 className="lg:text-3xl text-2xl font-bold text-center mb-6 font-Poppins">
                        Supprimer mon compte
                    </h1>
                    <p className="text-center text-gray-300 mb-8">
                        Cette action est irréversible. Assurez-vous de vouloir continuer.
                    </p>

                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div>
                            <label htmlFor="email" className="block text-gray-300 font-medium mb-1">
                                Adresse e-mail
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="w-full rounded-lg border border-gray-500 bg-transparent text-white px-4 py-2 focus:outline-none focus:ring-2 "
                                placeholder="exemple@email.com"
                            />
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-gray-300 font-medium mb-1">
                                Mot de passe
                            </label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                                className="w-full rounded-lg border border-gray-500 bg-transparent text-white px-4 py-2 focus:outline-none focus:ring-2 "
                                placeholder="••••••••"
                            />
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                disabled={isLoading}
                                className={`bg-color1 text-white font-semibold px-6 py-2 rounded-lg hover:bg-color6 transition duration-200 ${isLoading ? "opacity-70 cursor-not-allowed" : ""
                                    }`}
                            >
                                {isLoading ? "Suppression en cours..." : "Supprimer mon compte"}
                            </button>
                        </div>
                    </form>
                </div>
            </main>
            <Footer />
            <ToastContainer />
        </>
    );
}
